import * as React from 'react'
import { useState, useEffect } from 'react'
import MedalSilver from '../../../../assets/medal-silver.png'
import MedalGold from '../../../../assets/medal-gold.png'
import MedalDiamond from '../../../../assets/diamont.png'
import EmijiParty from '../../../../assets/party.png'
import EmojiStar from '../../../../assets/start.png'
import EmojiCash from '../../../../assets/cash.png'
import { Popover, Box } from '@mui/material'
import { StyledIconButton, StyledImg, StyledP } from './styles'
import { number } from 'prop-types'

const PopperPopupState = ({ nLeiturasMes }) => {
  const [metaLeiura, setMetaLeiura] = useState(0)
  useEffect(() => {
    setMetaLeiura(nLeiturasMes)
  }, [nLeiturasMes])
  const [anchorEl, setAnchorEl] = React.useState(null)

  const notification = {
    10: {
      icon: MedalSilver,
      iconMensagem: EmijiParty,
      messagem: 'Parabéns, agora você é um leitor nivel prata!!!'
    },
    11: {
      icon: MedalGold,
      iconMensagem: EmojiStar,
      messagem: 'Parabéns, agora você é um leitor nivel ouro!!!'
    },
    12: {
      icon: MedalDiamond,
      iconMensagem: EmojiCash,
      messagem: 'Parabéns, agora você é um leitor nivel diamante!!!'
    }
  }

  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  function scrollToBottom() {
    window.scroll(0, document.body.scrollHeight)
  }
  const open = Boolean(anchorEl)
  return (
    <>
      {nLeiturasMes < 10 ? (
        <div></div>
      ) : (
        <div>
          <StyledIconButton
            onClick={scrollToBottom}
            color="warning"
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            <StyledImg
              sx={{
                width: '36px',
                height: '40px',
                margin: 0
              }}
              src={notification[metaLeiura]?.icon}
            />
          </StyledIconButton>

          <Popover
            disableScrollLock={true}
            id="mouse-over-popover"
            sx={{
              pointerEvents: 'none'
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Box
              sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <StyledImg
                sx={{
                  width: '70px',
                  height: '70px'
                }}
                src={notification[metaLeiura]?.iconMensagem}
              />
              <div>
                <StyledP> {notification[metaLeiura]?.messagem} </StyledP>
              </div>
            </Box>
          </Popover>
        </div>
      )}
    </>
  )
}

PopperPopupState.propTypes = {
  nLeiturasMes: number
}

export default PopperPopupState
